import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

// Confirm a pause from the rejections report with an optional reason (and, for affiliates, whether they see it).
export function PauseReasonDialog({ option, kind, name, onCancel, onConfirm }) {
  const [note, setNote] = useState("");
  const [share, setShare] = useState(false);
  useEffect(() => {
    setNote("");
    setShare(false);
  }, [option]);
  return (
    <Dialog open={!!option} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="rounded-none border-2 border-black sm:max-w-md" data-testid="pause-reason-dialog">
        <DialogHeader>
          <DialogTitle className="font-chivo text-xl font-black">{option?.label}</DialogTitle>
          <DialogDescription>{name} — {option?.hint}</DialogDescription>
        </DialogHeader>
        <div>
          <label htmlFor="pause-reason" className="label-mono mb-1 block">Reason (optional)</label>
          <Textarea id="pause-reason" value={note} maxLength={300} rows={3} onChange={(e) => setNote(e.target.value)}
                    placeholder="e.g. Buyer says most leads are duplicates" className="rounded-none border-black"
                    data-testid="pause-reason-input" />
          <div className="mt-1 text-right text-[10px] text-zinc-500">{note.length}/300</div>
          {kind === "vendor" && (
            <label className="mt-2 flex cursor-pointer items-start gap-2 text-xs">
              <input type="checkbox" checked={share} disabled={!note.trim()} onChange={(e) => setShare(e.target.checked)}
                     className="mt-0.5" data-testid="pause-reason-share" />
              <span>Include this reason in the email to the affiliate <span className="text-zinc-500">(otherwise only admins see it)</span></span>
            </label>
          )}
        </div>
        <DialogFooter className="gap-2">
          <button type="button" onClick={onCancel} data-testid="pause-reason-cancel"
                  className="border border-black px-3 py-1.5 text-xs uppercase tracking-widest transition-colors duration-100 hover:bg-zinc-100">
            Cancel
          </button>
          <button type="button" onClick={() => onConfirm(note.trim(), share && !!note.trim())} data-testid="pause-reason-confirm"
                  className="border border-black bg-black px-3 py-1.5 text-xs uppercase tracking-widest text-white transition-colors duration-100 hover:bg-red-700">
            Pause
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
